import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, TrendingUp, Sparkles } from "lucide-react";
import { WeeklyRoutinesGraph } from "@/components/dashboard/WeeklyRoutinesGraph";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { useRoutineProgress } from "@/components/dashboard/graph/hooks/useRoutineProgress";
import { useWeeklyData } from "@/components/dashboard/graph/hooks/useWeeklyData";

interface WeeklyStatsSectionProps {
  routines: any[];
}

export const WeeklyStatsSection = ({ routines }: WeeklyStatsSectionProps) => {
  const [isStatsOpen, setIsStatsOpen] = useState(true);
  const [weekOffset] = useState(0);
  const { data: routineProgress } = useRoutineProgress(weekOffset);
  const { totalCompletedRoutines } = useWeeklyData(weekOffset, routines, routineProgress);

  return (
    <Collapsible
      open={isStatsOpen}
      onOpenChange={setIsStatsOpen}
      className="weekly-stats py-8"
    >
      <div className="mx-auto max-w-4xl">
        {/* Glass card container */}
        <div className="glass-card p-5 sm:p-6">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-3">
              {/* Animated icon */}
              <div className="relative">
                <div className="p-2.5 rounded-xl bg-primary/10 animate-pulse-glow">
                  <TrendingUp className="h-5 w-5 text-primary" />
                </div>
                <Sparkles className="h-3 w-3 text-accent absolute -top-1 -right-1 animate-float" />
              </div>
              
              <div className="space-y-0.5">
                <h2 className="text-xl sm:text-2xl font-heading font-bold text-primary">
                  Progreso Semanal
                </h2>
                <p className="text-muted-foreground text-sm flex items-center gap-2 sm:hidden">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-primary/20 text-primary font-bold text-xs">
                    {totalCompletedRoutines}
                  </span>
                  <span>rutinas completadas esta semana</span>
                </p>
              </div>
            </div>
            
            <CollapsibleTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                className="hover:bg-primary/10 rounded-full transition-all"
              >
                <ChevronDown 
                  className={`h-4 w-4 transition-transform duration-300 text-primary ${
                    isStatsOpen ? '' : 'rotate-180'
                  }`} 
                />
              </Button>
            </CollapsibleTrigger>
          </div>
          
          <CollapsibleContent className="space-y-4 animate-fade-in">
            <WeeklyRoutinesGraph routines={routines} />
          </CollapsibleContent>
        </div>
      </div>
    </Collapsible>
  );
};
